import { Input, Flex as WebFlex } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { PDFOnly } from '../../../../summary/components/PDFOnly.tsx';
import { Typography } from '../../../../summary/components/Typography.tsx';
import { WebOnly } from '../../../../summary/components/WebOnly.tsx';
import { SummarySection } from '../../SummarySection.tsx';
import { SummaryTableHorizontal } from '../../SummaryTableHorizontal.js';
import { TitleAndExportToggleLockup } from '../../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../../types.ts';
import { PairedCostSettingsBreakdown } from '../PairedCostSettingsBreakdown.tsx';
import { isCosted } from '../isCosted.ts';
import { getAdjustmentBreakdownGlaProps } from './getAdjustmentBreakdownGlaProps.ts';

export const AdjustmentBreakdownGla = (props: Tkv2PairedCostSummaryInterfaceV2) => {
  const commentaryProps = props.exportableCommentaries.mainDwelling;
  const [commentary, setCommentary] = useState(commentaryProps.commentary);

  const propertyTypeSet = new Set(props.propertyTypes);
  const { title, columns, description } = getAdjustmentBreakdownGlaProps(propertyTypeSet);

  if (!isCosted(props.results, 'mainDwelling')) {
    return null;
  }

  return (
    <SummarySection>
      <TitleAndExportToggleLockup
        {...props}
        title={title}
        id="isGlaCommentaryInExport"
        commentary={commentaryProps}
      />
      <Typography variant="body1">{description}</Typography>
      <WebOnly>
        <WebFlex height="1rem" />
      </WebOnly>
      <Typography variant="body1">
        The GLA adjustment equals the subject’s dwelling cost minus the comparable’s dwelling cost
        plus the quality adjustment (if applicable). To calculate the price/sf divide the adjustment
        by the difference in square footage between the two properties.
      </Typography>
      <PDFOnly>
        <Typography variant="body1">{commentaryProps.commentary}</Typography>
      </PDFOnly>
      <SummaryTableHorizontal
        {...props}
        compSequence={props.compSequence}
        summary={props}
        columns={columns}
      />
      <PairedCostSettingsBreakdown {...props} type="mainDwelling" />
      <WebOnly>
        <WebFlex marginTop="1rem" width="40rem">
          <Input
            type="multiline"
            onChange={setCommentary}
            value={commentary}
            onClear={() => setCommentary('')}
            onBlur={() => commentaryProps.updateCommentary(commentary)}
            resize="both"
            label="Commentary"
            size="sm"
          />
        </WebFlex>
      </WebOnly>
    </SummarySection>
  );
};
